import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { ApproveDoubleVerificationModal } from "./ApproveDoubleVerificationModal";
import { OPERATION_TYPE, QuoteEntity } from "interfaces";
import { RelevantOperationType } from "services";
import { ButtonProps } from "antd";
import { useEffect } from "react";

type Props = {
  btnTitle?: string;
  disabled?: boolean;
  tooltip?: string;
  operationPath: RelevantOperationType;
  walletAddress?: string;
  requestId?: string | undefined;
  quoteId?: string | undefined;
  onStateReset?: () => void;
  btnProps?: ButtonProps;
};

export const ApproveDoubleVerificationBtn = observer(
  ({
    btnTitle = "Подтвердить данные заявки",
    disabled = false,
    tooltip,
    operationPath,
    walletAddress,
    requestId,
    onStateReset,
    btnProps,
  }: Props) => {
    const { actionModals, quotes } = useStores();

    function openApproveModalHandler() {
      quotes.setQuoteSelectedId(requestId ?? "");
      actionModals.open(
        () => (
          <ApproveDoubleVerificationModal
            operationPath={operationPath}
            walletAddress={walletAddress}
            requestId={requestId}
          />
        ),
        {
          title: "Верификация данных",
          width: "700px",
        }
      );
      onStateReset?.();
    }

    return (
      <CustomButton onClick={openApproveModalHandler} disabled={disabled} tooltip={tooltip} {...btnProps}>
        {btnTitle}
      </CustomButton>
    );
  }
);
